<template>
  <div>
    <v-dialog :value="value" persistent scrollable max-width="325px">
      <v-card>
        <div class="text-xs-right">
          <v-btn fab small flat @click="$emit('input', false)">
            <v-icon>close</v-icon>
          </v-btn>
        </div>
        <div>
          <v-divider></v-divider>
          <VEmojiPicker @select="selectEmoji" :showSearch="false" />
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { VEmojiPicker } from 'v-emoji-picker'

export default {
  props: ['value'],
  components: {
    VEmojiPicker
  },
  data() {
    return {
      isVisible: false
    }
  },
  methods: {
    selectEmoji(emoji) {
      // console.log(emoji)
      this.$emit('sendEmoji', {
        emoji: emoji
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/elements/EmojiList.vue